module.exports = __webpack_public_path__ + "img/lg_ring_g_0_1_null@3x.a16df6d7.png";